import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { AppCache } from '@rd-web-markets/shared/dist/util/AppCache';
import isEqual from 'lodash.isequal';

export const listsTranslationsService = {
  all: async (locale) => {
    const cache = AppCache.getCache('translations')

    if (cache[locale]) {
      return cache[locale]
    }

    const res = await fetch(`/api/lists/translations?locale=${locale}`, request.get);

    cache[locale] = res

    return cache[locale]
  },

};
